import React, { useState, useEffect } from "react";
import "../../style/component/layout/Announcement.css";
import { useAnnouncementContent } from "../../hooks/useAnnouncementContent";

function Announcement({ Message } = {}) {
  const { items } = useAnnouncementContent();
  const [displayMessage, setDisplayMessage] = useState("");
  const [messageIndex, setMessageIndex] = useState(0);
  const [currentItemId, setCurrentItemId] = useState(null);

  useEffect(() => {
    if (items.length > 0) {
      let nextIndex = 0;

      if (currentItemId !== null) {
        const matchedIndex = items.findIndex((item) => item.id === currentItemId);
        if (matchedIndex >= 0) {
          nextIndex = matchedIndex;
        } else if (messageIndex < items.length) {
          nextIndex = messageIndex;
        }
      } else if (messageIndex < items.length) {
        nextIndex = messageIndex;
      }

      setMessageIndex(nextIndex);
      setDisplayMessage(items[nextIndex]?.message || "");
      setCurrentItemId(items[nextIndex]?.id ?? null);
    } else {
      setMessageIndex(0);
      setCurrentItemId(null);
      setDisplayMessage("");
    }
  }, [items]);

  useEffect(() => {
    if (items.length === 0) return;

    const handleAnimationIteration = () => {
      setMessageIndex((prev) => {
        const nextIndex = (prev + 1) % items.length;
        setDisplayMessage(items[nextIndex]?.message || "");
        setCurrentItemId(items[nextIndex]?.id ?? null);
        return nextIndex;
      });
    };

    const trackElement = document.querySelector(".announcement-track");
    if (trackElement) {
      trackElement.addEventListener("animationiteration", handleAnimationIteration);
      return () => {
        trackElement.removeEventListener("animationiteration", handleAnimationIteration);
      };
    }
  }, [items]);

  const finalMessage = Message || displayMessage;

  return (
    <div className="announcement-bar">
      <div className="announcement-track">
        <span className="announcement-text">{finalMessage}</span>
      </div>
    </div>
  );
}

export default Announcement;
